<template functional>
    <v-card elevation="2" shaped color="#851e31" width="180" class="my-5 mx-2">
        <v-card-text class="text-center white--text pb-5">
            <p class="font-weight-bold" style="margin-bottom: 4px">
                {{props.titulo}}
            </p>
            <div>Importe: {{ props.total }} €</div>
            <div>Comisión: {{ props.comision }} €</div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: ['titulo', 'total', 'comision']
    }
</script>